import { css } from 'styled-components'

export const textLink = ( theme, color = 'green400' ) => css`
  color: ${ theme.getColor( color ) };
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;
`
